var table_viewer_default = {
  "viewMode": "XZAlC",
  "editMode": "BR-mX",
  "container": "V9i9D",
  "cell": "MFCnN"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
